import {Slide} from "../model/types";
import {Video} from "@/shared/ui/Video";
import {Picture} from "@/shared/ui/Picture";
import {Link} from "@/shared/ui/Link";
import styles from "./MainCarousel.module.scss";

type Props = {
    slide: Slide;
    isMobile: boolean;
    className?: string;
}

export const MainCarouselSlide = ({slide, isMobile, className}: Props) => {

    const content = slide.video_path && slide.video_path_mobile ? (
        <Video
            poster={isMobile ? slide.imgMobilePath : slide.imgPath}
            sources={[isMobile ? slide.video_path_mobile : slide.video_path]}
            className={styles.slideVideo}
            uiControls={false}
            autoPlay
            loop
        />
    ) : (
        <Picture
            src={slide.imgPath}
            srcMobile={slide.imgMobilePath}
            alt={slide.label}
            classes={{root: styles.slideImage}}
        />
    );
    const Wrapper = slide.link ? Link : "div";

    return (
        <Wrapper {...(slide.link && { href: slide.link })} className={className}>
            {content}
        </Wrapper>
    );
}
